import {
  EKwikUIButtonApiCallTimerFormat,
  TKwikUIButtonApiCallTimerFormat
} from "./button-api-call.definitions";

export const paddedTime = (time: number) => {
  return time.toString().padStart(2, "0");
};

export const getTimerMessage = (
  messageWithTimerPlaceholder = "{{time}}",
  format = EKwikUIButtonApiCallTimerFormat.ss,
  time
) => {
  const formattedTime = getFormattedTimeDuration(Number(time), format);
  return messageWithTimerPlaceholder.replace("{{time}}", formattedTime);
};

export const getFormattedTimeDuration = (
  value: number,
  format: TKwikUIButtonApiCallTimerFormat
): string => {
  let years;
  let months;
  let weeks;
  let days;
  let hours;
  let minutes;
  let seconds;

  switch (format) {
    case EKwikUIButtonApiCallTimerFormat.ss:
      return `${value}`;

    case EKwikUIButtonApiCallTimerFormat.SS:
      return `${value} Seconds`;

    case EKwikUIButtonApiCallTimerFormat.mm:
      minutes = Math.floor(value / 60);
      return `${minutes}`;

    case EKwikUIButtonApiCallTimerFormat.MM:
      minutes = Math.floor(value / 60);
      return `${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.mm_ss:
      minutes = Math.floor(value / 60);
      seconds = value % 60;
      return `${paddedTime(minutes)}:${paddedTime(seconds)}`;

    case EKwikUIButtonApiCallTimerFormat.MM_SS:
      minutes = Math.floor(value / 60);
      seconds = value % 60;
      return `${minutes} Minutes and ${seconds} Seconds`;

    case EKwikUIButtonApiCallTimerFormat.hh:
      hours = Math.floor(value / 3600);
      return `${hours}`;

    case EKwikUIButtonApiCallTimerFormat.hh_mm:
      hours = Math.floor(value / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${paddedTime(hours)}:${paddedTime(minutes)}`;

    case EKwikUIButtonApiCallTimerFormat.hh_mm_ss:
      hours = Math.floor(value / 3600);
      minutes = Math.floor((value % 3600) / 60);
      seconds = value % 60;
      return `${paddedTime(hours)}:${paddedTime(minutes)}:${paddedTime(
        seconds
      )}`;

    case EKwikUIButtonApiCallTimerFormat.HH:
      hours = Math.floor(value / 3600);
      return `${hours} Hours`;

    case EKwikUIButtonApiCallTimerFormat.HH_MM:
      hours = Math.floor(value / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${hours} Hours and ${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.HH_MM_SS:
      hours = Math.floor(value / 3600);
      minutes = Math.floor((value % 3600) / 60);
      seconds = value % 60;
      return `${hours} Hours, ${minutes} Minutes and ${seconds} Seconds`;

    case EKwikUIButtonApiCallTimerFormat.DAYS:
      days = Math.floor(value / 86400);
      return `${days} Days`;

    case EKwikUIButtonApiCallTimerFormat.DAYS_HH:
      days = Math.floor(value / 86400);
      hours = Math.floor((value % 86400) / 3600);
      return `${days} Days and ${hours} Hours`;

    case EKwikUIButtonApiCallTimerFormat.DAYS_HH_MM:
      days = Math.floor(value / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${days} Days, ${hours} Hours and ${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.DAYS_HH_MM_SS:
      days = Math.floor(value / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      seconds = value % 60;
      return `${days} Days, ${hours} Hours, ${minutes} Minutes and ${seconds} Seconds`;

    case EKwikUIButtonApiCallTimerFormat.WEEKS:
      weeks = Math.floor(value / 604800);
      return `${weeks} Weeks`;

    case EKwikUIButtonApiCallTimerFormat.WEEKS_DAYS:
      weeks = Math.floor(value / 604800);
      days = Math.floor((value % 604800) / 86400);
      return `${weeks} Weeks and ${days} Days`;

    case EKwikUIButtonApiCallTimerFormat.WEEKS_DAYS_HH:
      weeks = Math.floor(value / 604800);
      days = Math.floor((value % 604800) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      return `${weeks} Weeks, ${days} Days and ${hours} Hours`;

    case EKwikUIButtonApiCallTimerFormat.WEEKS_DAYS_HH_MM:
      weeks = Math.floor(value / 604800);
      days = Math.floor((value % 604800) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${weeks} Weeks, ${days} Days, ${hours} Hours and ${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.MONTHS:
      months = Math.floor(value / (86400 * 30.44));
      return `${months} Months`;

    case EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS:
      months = Math.floor(value / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      return `${months} Months and ${days} Days`;

    case EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS_HH:
      months = Math.floor(value / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      return `${months} Months, ${days} Days and ${hours} Hours`;

    case EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS_HH_MM:
      months = Math.floor(value / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${months} Months, ${days} Days, ${hours} Hours and ${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.MONTHS_DAYS_HH_MM_SS:
      months = Math.floor(value / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      seconds = value % 60;
      return `${months} Months, ${days} Days, ${hours} Hours, ${minutes} Minutes and ${seconds} Seconds`;

    case EKwikUIButtonApiCallTimerFormat.YEARS:
      years = Math.floor(value / (86400 * 365.25));
      return `${years} Years`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS:
      years = Math.floor(value / (86400 * 365.25));
      weeks = Math.floor((value % (86400 * 365.25)) / 604800);
      return `${years} Years and ${weeks} Weeks`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS:
      years = Math.floor(value / (86400 * 365.25));
      weeks = Math.floor((value % (86400 * 365.25)) / 604800);
      days = Math.floor((value % 604800) / 86400);
      return `${years} Years, ${weeks} Weeks and ${days} Days`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS_HH:
      years = Math.floor(value / (86400 * 365.25));
      weeks = Math.floor((value % (86400 * 365.25)) / 604800);
      days = Math.floor((value % 604800) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      return `${years} Years, ${weeks} Weeks, ${days} Days and ${hours} Hours`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS_HH_MM:
      years = Math.floor(value / (86400 * 365.25));
      weeks = Math.floor((value % (86400 * 365.25)) / 604800);
      days = Math.floor((value % 604800) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${years} Years, ${weeks} Weeks, ${days} Days, ${hours} Hours and ${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_WEEKS_DAYS_HH_MM_SS:
      years = Math.floor(value / (86400 * 365.25));
      weeks = Math.floor((value % (86400 * 365.25)) / 604800);
      days = Math.floor((value % 604800) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      seconds = value % 60;
      return `${years} Years, ${weeks} Weeks, ${days} Days, ${hours} Hours, ${minutes} Minutes and ${seconds} Seconds`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS:
      years = Math.floor(value / (86400 * 365.25));
      months = Math.floor((value % (86400 * 365.25)) / (86400 * 30.44));
      return `${years} Years and ${months} Months`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS:
      years = Math.floor(value / (86400 * 365.25));
      months = Math.floor((value % (86400 * 365.25)) / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      return `${years} Years, ${months} Months and ${days} Days`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS_HH:
      years = Math.floor(value / (86400 * 365.25));
      months = Math.floor((value % (86400 * 365.25)) / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      return `${years} Years, ${months} Months, ${days} Days and ${hours} Hours`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS_HH_MM:
      years = Math.floor(value / (86400 * 365.25));
      months = Math.floor((value % (86400 * 365.25)) / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      return `${years} Years, ${months} Months, ${days} Days, ${hours} Hours and ${minutes} Minutes`;

    case EKwikUIButtonApiCallTimerFormat.YEARS_MONTHS_DAYS_HH_MM_SS:
      years = Math.floor(value / (86400 * 365.25));
      months = Math.floor((value % (86400 * 365.25)) / (86400 * 30.44));
      days = Math.floor((value % (86400 * 30.44)) / 86400);
      hours = Math.floor((value % 86400) / 3600);
      minutes = Math.floor((value % 3600) / 60);
      seconds = value % 60;
      return `${years} Years, ${months} Months, ${days} Days, ${hours} Hours, ${minutes} Minutes and ${seconds} Seconds`;

    default:
      return `${value}`;
  }
};
